import { Inject, Singleton } from '@denishussar/html5-game-engine';
import { Texture } from 'pixi.js';
import { ShopModel } from './ShopModel';
import { AlbumsLibrary } from '../../game/Models/AlbumsLibrary';
import { UserModel } from '../../game/Models/UserModel';
import { IReleasePlatform } from '../../index';
import { IPictureData } from '../Services/CloudDB/Contract';
import {ModalsNames} from "../Common/MadalsManager/ModalsList";
import { BombBooster } from '../Logic/Boosters/Bomb';
import { BoosterRenderer } from '../Utils/BoosterRenderer';

export enum GameStateEnum {
    none,
    menu,
    game,
    album,
    main,
    win,
    shop,
    shopLife,
    shopNeedle,
    catalog,
    achievement,
}

export enum InstrumentTypeEnum {
    none,
    preview,
    hand,
    paint,
    booster
}

export enum BoosterTypeEnum {
    none,
    yarn,
    needle,
    hook,
    bucket
}

export enum BoosterNameEnum {
    needle = 'needle',
    yarn = 'yarn',
    bucket = 'bucket',
}

@Singleton
export class GameModel {
    // Constants
    static pixelSize: number = 32;
    static minimalVisibleEditedPixelSize = 25;
    static maximalVisibleEditedPixelSize = 60;
    static alphabetSymbolList: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    static alphabetSymbol: string[] = [];
    static alphabetNumberMax: number = 30;

    static gameOutbordingFraction = 0.10;

    public gameWidth: number = 1920;
    public gameHeight: number = 1440;

    public isVideoPlayed: boolean = false;

    public gameState: GameStateEnum = GameStateEnum.none;
    public showFullscreen: boolean = false;
    public soundOff: boolean = false;

    // Instrument
    public instrumentType: InstrumentTypeEnum = InstrumentTypeEnum.preview;
    public boosterType: BoosterTypeEnum = BoosterTypeEnum.none;

    public isScrollEnabled: boolean = false;
    public paintEnabled: boolean = false;

    // Picture
    public picture: IPictureData = null;
    public texture: Texture = null;
    public pictureBuffer: Uint8ClampedArray = null;
    public saveTexture: Texture = null;
    public saveBuffer: Uint8ClampedArray = null;

    public pixels: any = [];
    public filledPixels: any = [];
    public filledPixels2d: number[] = [];
    public filledPixelsCount: number = 0;
    public filledPixelsColorTotalCount: number[] = [];
    public filledPixelsColorCount: number[] = [];

    // Palette
    public palette: number[] = [];
    public paletteColor: number = 0;
    public paletteColorIndex: number = 0;

    public currentPictureWidth: number = 0;
    public currentPictureHeight: number = 0;

    // Boosters
    public boosterBallPartOfPictureWidth = 0.24;
    public boosterBallThreadSize = 0;
    public boosterBallThreadEnabled = false;
    public boosterNeedleSize = 2;
    public boosterNeedleEnabled = false;
    public activeBooster?: BoosterRenderer;

    // User balance TODO: replace to UserModel

    public addsCooldownTimestamp = 0;
    public addsDay = 0;

    public userBalanceCoins = 0;
    public userBalanceLivesAvailable = -1; // Значение доступного количество жизней. Значение -1 - бесконечная жизнь
    public userBalanceLivesCount = 5; // Значение количества жизней
    public userBalanceLivesTimestamp = new Date().getTime();  // Таймштамп таймера накопления очередной жизни
    public userBalanceLivesTime = 0; // Значение истекшего времени, мс;
    public userBalanceLivesAddPeriod = 5 * 60 * 1000; // Период добавления жизни, мс;

    public userBalanceLivesUnlimitedPeriod = 0// 24 * 60 * 60 * 1000 // Период безлимитной жизни
    public userBalanceLivesUnlimitedTimestamp = 0; // Таймштамп таймера действия бесконечной жизни
    public userBalanceLivesUnlimitedTime = 0;

    public userBalanceBoosterLine = 1;
    public userBalanceBoosterBrush = 3;
    public userBalanceBoosterHook = 2;
    public userBalanceBoosterBucket = 1;

    // counters
    public stitchCount = 0;
    public dragCount = 0;
    public needleCount = 0;
    public bucketCount = 0;
    public yarnCount = 0;
    public zoomInCount = 0;
    public zoomOutCount = 0;
    public storeCount = 0;
    public timeSpent = 0;
    public timeStart = 0;
    public rewardsCount = 0;

    //

    public isSetPictureForAds: boolean = false;

    //
    public currentAlbum: string = AlbumsLibrary.MY_COLLECTION;
    public platform?: IReleasePlatform;

    constructor(
        @Inject public shopModel: ShopModel,
        @Inject public albumLibrary: AlbumsLibrary,
        @Inject public userModel: UserModel,
    ) {
        //@ts-ignore
        this.picture = false;
    }
}
